import VxeTableColumnComponent from '../table/src/column';
import { dynamicApp } from '../dynamics';
export var VxeColumn = Object.assign(VxeTableColumnComponent, {
    install: function (app) {
        app.component(VxeTableColumnComponent.name, VxeTableColumnComponent);
        // 兼容旧用法
        app.component('VxeTableColumn', VxeTableColumnComponent);
    }
});
export var Column = VxeColumn;
dynamicApp.component(VxeTableColumnComponent.name, VxeTableColumnComponent);
// 兼容旧用法
dynamicApp.component('VxeTableColumn', VxeTableColumnComponent);
export default VxeColumn;
